import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap,first } from 'rxjs/operators';
import { RootState } from 'src/app/store/root.reducer';
import { Store } from '@ngrx/store';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { APIEndpoint } from 'src/app/models/options/api-endpoint';
import * as OrderUIActions from '../../store/ui/order/actions/order-ui.actions'
import * as UserActions from '../../store/user/actions/user.actions'
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
@Injectable()
export class NetworkErrorInterceptor implements HttpInterceptor {

  constructor(
    private store: Store<RootState>,
    private notification: NzNotificationService,
    private modal: NzModalService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        response => {
          // console.log(response)
        },
        (error: HttpErrorResponse) => {
          switch (error.status) {
            case 413: {
              this.notification.create(
                'error',
                'Error Message',
                `Network Error: ${error.status}`
              );
              // if(error.url.indexOf(APIEndpoint.SALESORDERS_BULKUPLOAD)!==-1){
              //   this.store.dispatch(UIActions.setUISelectedOrderBulkUploadProgress({ uiSelectedOrderBulkUploadProgress: 3 }))
              // }else{

              // }
              this.store.dispatch(OrderUIActions.setuiOrderDetailLoading({ uiOrderDetailLoading: {loadingSwitch:false} }))
              break
            }
            case 429: {
              this.notification.create(
                'error',
                'Error Message',
                `Network Error: ${error.status}`
              );
              this.store.dispatch(OrderUIActions.setuiOrderDetailLoading({ uiOrderDetailLoading: {loadingSwitch:false} }))
              break
            }
            case 404: {
              this.notification.create(
                'error',
                'Error Message',
                `Network Error: ${error.status}`
              );
              this.store.dispatch(OrderUIActions.setuiOrderDetailLoading({ uiOrderDetailLoading: {loadingSwitch:false} }))
              break
            }
            case 400: {
                this.notification.create(
                  'error',
                  'Error Message',
                  `Network Error: ${error.status}`
                );
              this.store.dispatch(OrderUIActions.setuiOrderDetailLoading({ uiOrderDetailLoading: {loadingSwitch:false} }))
              break
            }
            case 405: {
              this.notification.create(
                'error',
                'Error Message',
                `Network Error: ${error.status}`
              );
              this.store.dispatch(OrderUIActions.setuiOrderDetailLoading({ uiOrderDetailLoading: {loadingSwitch:false} }))
              break
            }
            case 504: {
              this.notification.create(
                'error',
                'Error Message',
                `Network Error: ${error.status}`
              );
              this.store.dispatch(OrderUIActions.setuiOrderDetailLoading({ uiOrderDetailLoading: {loadingSwitch:false} }))
              break
            }
            case 406: {
              //406 on approve SO error will have stock check and credit check, so need to check return error

                this.notification.create(
                  'error',
                  'Error Message',
                  `Network Error: ${error.status}`
                )
              break
            }
            case 500: {
              this.notification.create(
                'error',
                'Error Message',
                `Network Error: ${error.status}`
              );

              break
            }
            case 503: {
              this.notification.create(
                'error',
                'Error Message',
                `Network Error: ${error.status}`
              );
              this.store.dispatch(OrderUIActions.setuiOrderDetailLoading({ uiOrderDetailLoading: {loadingSwitch:false} }))
              break
            }
            case 409: {
              // console.error(`'net work error:'${error.status}`)
              console.log(error)
                this.notification.create(
                  'error',
                  'Error Message',
                  `Network Error: ${error.status}`
                );

              this.store.dispatch(OrderUIActions.setuiOrderDetailLoading({ uiOrderDetailLoading: {loadingSwitch:false} }))
              break
            }
            default: {
              // this.store.dispatch(UserActions.requestDefaultError())
              // break
            }
          }
        }
      )
    )
  }
}
